<div class="lead" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></div>
